<template>
  <div>
    <b-row>
      <b-col v-if="fetchData" style="font-size: 13px !important; color: #red; text-align:center;">
        working on ...
      </b-col>
    </b-row>
    <b-row>
      <b-col v-if="!fetchData && getDataFlag" style="font-size: 13px !important; color: #red; text-align:center;">
        <p class="text-danger">Questions that are not linked with PO/PSO will be ignored</p>
      </b-col>
    </b-row>
    <b-row v-if="!fetchData">
      <b-col v-if="(getConfigFlag && !setConfigFlag)">
        <div class="d-flex justify-content-between">
          <b-button @click="ClearSurveyIds()" variant="primary" size="sm">Clear</b-button>
        </div>
        Program exit survey
        <table class="table table-bordered table-striped">
          <thead class="thead-dark text-left">
            <tr>
              <td></td>
              <td></td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(survey, courseIndex) in program_exit_surveys" :key="courseIndex">
              <td class="align-middle">
                <b-form-radio v-model="survey_ids.programme_exit_survey" name="programme_exit_survey"
                  :value="survey.id"></b-form-radio>
              </td>
              <td class="align-middle">
                {{ survey.name }}
              </td>
            </tr>
          </tbody>
        </table>
      </b-col>


      <b-col v-if="(getDataFlag) && survey_ids.programme_exit_survey != null">
        Programme exit survey data
        <table class="table table-bordered table-striped">
          <thead class="thead-dark text-left">
            <tr>
              <th>Q No.</th>
              <th>Question</th>
              <th>PO/PSO</th>
              <th>Choices</th>
              <th>Count</th>
              <th>Avg. Score</th>
              <th>%</th>
              <th>Attainment Level</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(question, qIndex) in programmeexitsurvey['exit_survey_questions']" :key="qIndex">
              <td>{{ question.question_no }}</td>
              <td>{{ question.name }}</td>
              <td>
                <span>
                  {{ question.programme_outcomes.map(po => programme_outcomes[po].code).join(', ') }}
                </span>
                <span>
                  {{ question.programme_specific_outcomes.map(pso => programme_specific_outcomes[pso].code).join(', ') }}
                </span>
              </td>

              <td>
                <span v-for="(choice, cIndex) in question.choices" :key="cIndex">{{ choice.name }}({{ choice.score }})
                  <br></span>
              </td>
              <td>
                <span v-for="(choice, cIndex) in question.choices" :key="cIndex">{{
                  Number( programmeexitsurvey['questionsWithChoices'][question.id].choices[cIndex].offline_evaluation_count?
                  programmeexitsurvey['questionsWithChoices'][question.id].choices[cIndex].offline_evaluation_count:
                  programmeexitsurvey['questionAnswerSummery'][question.id].choices[choice.id].length)
                  }} <br></span>
              </td>
              <td>{{ Math.round(programmeexitsurvey['questionAnswerSummery'][question.id].avg_score * 100) / 100 }}</td>
              <td>{{ Math.round(programmeexitsurvey['questionAnswerSummery'][question.id].persantage * 100) / 100 }}
              </td>
              <td>
                <span v-if="programmeexitsurvey['questionAnswerSummery'][question.id].attainment_level">
                  {{ programmeexitsurvey['questionAnswerSummery'][question.id].attainment_level }}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </b-col>
      <b-col v-if="getReportFlag && survey_ids.programme_exit_survey != null">
        Programme Exit survey report
        <table class="table table-bordered table-striped">
          <thead class="thead-dark text-left">
            <tr>
              <th>PO/PSO</th>
              <th v-for="(po, poIndex) in programme_outcomes" :key="'po1' + poIndex">
                {{ po.code }}</th>
              <th v-for="(pso, psoIndex) in programme_specific_outcomes" :key="'pso1' + psoIndex">
                {{ pso.code }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>Avg. Score</th>
              <td v-for="(po, poIndex) in programme_outcomes" :key="'po' + poIndex">
                <span v-if="programmeexitsurvey['po_avg_scores'][po.id]>0">
                  {{ Math.round(programmeexitsurvey['po_avg_scores'][po.id] * 100) / 100 }}
                </span>
                <span v-else>
                    -
                </span>
              </td>
              <td v-for="(pso, psoIndex) in programme_specific_outcomes" :key="'pso' + psoIndex">
                <span v-if="programmeexitsurvey['pso_avg_scores'][pso.id]>0">
                  {{ Math.round(programmeexitsurvey['pso_avg_scores'][pso.id] * 100) / 100 }}
                </span>
                <span v-else>
                    -
                </span>
              </td>
            </tr>
            <tr>
              <th>Attainment. Score out of 3</th>

              <td v-for="(po, poIndex) in programme_outcomes" :key="'po' + poIndex">
                <span v-if="programmeexitsurvey['po_attainment_scores'][po.id]>0">
                  {{ Math.round(programmeexitsurvey['po_attainment_scores'][po.id] * 100) / 100 }}
                </span>
                <span v-else>
                    -
                </span>
              </td>
              <td v-for="(pso, psoIndex) in programme_specific_outcomes" :key="'pso' + psoIndex">
                <span v-if="programmeexitsurvey['pso_attainment_scores'][pso.id]>0">
                  {{ Math.round(programmeexitsurvey['pso_attainment_scores'][pso.id] * 100) / 100 }}
                </span>
                <span v-else>
                    -
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </b-col>
    </b-row>
    <b-row v-if="!fetchData">
      <b-col v-if="(getConfigFlag && !setConfigFlag)">
        Faculty surveys
        <table class="table table-bordered table-striped">
          <thead class="thead-dark text-left">
            <tr>
              <td></td>
              <td></td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(survey, courseIndex) in faculty_surveys" :key="courseIndex">
              <td class="align-middle">
                <b-form-radio v-model="survey_ids.faculty_survey" name="faculty_survey" :value="survey.id"></b-form-radio>
              </td>
              <td class="align-middle">
                {{ survey.name }}
              </td>
            </tr>
          </tbody>
        </table>
      </b-col>
      <b-col v-if="(getDataFlag) && survey_ids.faculty_survey !=null">
        Faculty survey data
        <table class="table table-bordered table-striped">
          <thead class="thead-dark text-left">
            <tr>
              <th>Q No.</th>
              <th>Question</th>
              <th>PO/PSO</th>
              <th>Choices</th>
              <th>Count</th>
              <th>Avg. Score</th>
              <th>%</th>
              <th>Attainment Level</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(question, qIndex) in facultysurvey['exit_survey_questions']" :key="qIndex">
              <td>{{ question.question_no }}</td>
              <td>{{ question.name }}</td>
              <td>
                <span>
                  {{ question.programme_outcomes.map(po => programme_outcomes[po].code).join(', ') }}
                </span>
                <span>
                  {{ question.programme_specific_outcomes.map(pso => programme_specific_outcomes[pso].code).join(', ') }}
                </span>
              </td>
              <td>
                <span v-for="(choice, cIndex) in question.choices" :key="cIndex">{{ choice.name }}({{ choice.score }})
                  <br></span>
              </td>
              <td>
                <span v-for="(choice, cIndex) in question.choices" :key="cIndex">{{
                  Number(facultysurvey['questionsWithChoices'][question.id].choices[cIndex].offline_evaluation_count?
                  facultysurvey['questionsWithChoices'][question.id].choices[cIndex].offline_evaluation_count:
                  facultysurvey['questionAnswerSummery'][question.id].choices[choice.id].length
                  )}} <br></span>
              </td>
              <td>{{ Math.round(facultysurvey['questionAnswerSummery'][question.id].avg_score * 100) / 100 }}</td>
              <td>{{ Math.round(facultysurvey['questionAnswerSummery'][question.id].persantage * 100) / 100 }}</td>
              <td>
                <span v-if="facultysurvey['questionAnswerSummery'][question.id].attainment_level">
                  {{ facultysurvey['questionAnswerSummery'][question.id].attainment_level }}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </b-col>
      <b-col v-if="getReportFlag && survey_ids.faculty_survey !=null">
        Faculty survey report
        <table class="table table-bordered table-striped">
          <thead class="thead-dark text-left">
            <tr>
              <th>PO/PSO</th>
              <th v-for="(po, poIndex) in programme_outcomes" :key="'po1' + poIndex">
                {{ po.code }}</th>
              <th v-for="(pso, psoIndex) in programme_specific_outcomes" :key="'pso1' + psoIndex">
                {{ pso.code }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>Avg. Score</th>

              <td v-for="(po, poIndex) in programme_outcomes" :key="'po' + poIndex">
                <span v-if="facultysurvey['po_avg_scores'][po.id]>0">
                  {{ Math.round(facultysurvey['po_avg_scores'][po.id] * 100) / 100 }}
                </span>
                <span v-else>
                    -
                </span>
              </td>
              <td v-for="(pso, psoIndex) in programme_specific_outcomes" :key="'pso' + psoIndex">
                <span v-if="facultysurvey['pso_avg_scores'][pso.id]>0">
                  {{ Math.round(facultysurvey['pso_avg_scores'][pso.id] * 100) / 100 }}
                </span>
                <span v-else>
                    -
                </span>
              </td>
            </tr>
            <tr>
              <th>Attainment. Score out of 3</th>

              <td v-for="(po, poIndex) in programme_outcomes" :key="'po' + poIndex">
                <span v-if="facultysurvey['po_attainment_scores'][po.id]>0">
                  {{ Math.round(facultysurvey['po_attainment_scores'][po.id] * 100) / 100 }}
                </span>
                <span v-else>
                    -
                </span>
              </td>
              <td v-for="(pso, psoIndex) in programme_specific_outcomes" :key="'pso' + psoIndex">
                <span v-if="facultysurvey['pso_attainment_scores'][pso.id]>0">
                  {{ Math.round(facultysurvey['pso_attainment_scores'][pso.id] * 100) / 100 }}
                </span>
                <span v-else>
                    -
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </b-col>
    </b-row>
    <b-row v-if="!fetchData">
      <b-col v-if="(getConfigFlag && !setConfigFlag)">
        Alumni surveys
        <table class="table table-bordered table-striped">
          <thead class="thead-dark text-left">
            <tr>
              <td></td>
              <td></td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(survey, courseIndex) in alumini_surveys" :key="courseIndex">
              <td class="align-middle">
                <b-form-radio v-model="survey_ids.alumini_survey" name="alumini_survey" :value="survey.id"></b-form-radio>
              </td>
              <td class="align-middle">
                {{ survey.name }}
              </td>
            </tr>
          </tbody>
        </table>
      </b-col>

      <b-col v-if="(getDataFlag && survey_ids.alumini_survey !=null)">
        Alumni survey data
        <table class="table table-bordered table-striped">
          <thead class="thead-dark text-left">
            <tr>
              <th>Q No.</th>
              <th>Question</th>
              <th>PO/PSO</th>
              <th>Choices</th>
              <th>Count</th>
              <th>Avg. Score</th>
              <th>%</th>
              <th>Attainment Level</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(question, qIndex) in aluminisurvey['exit_survey_questions']" :key="qIndex">
              <td>{{ question.question_no }}</td>
              <td>{{ question.name }}</td>
              <td>
                <span>
                  {{ question.programme_outcomes.map(po => programme_outcomes[po].code).join(', ') }}
                </span>
                <span>
                  {{ question.programme_specific_outcomes.map(pso => programme_specific_outcomes[pso].code).join(', ') }}
                </span>
              </td>
              <td>
                <span v-for="(choice, cIndex) in question.choices" :key="cIndex">{{ choice.name }}({{ choice.score }})
                  <br></span>
              </td>
              <td>
                <span v-for="(choice, cIndex) in question.choices" :key="cIndex">{{
                  Number(aluminisurvey['questionsWithChoices'][question.id].choices[cIndex].offline_evaluation_count?
                  aluminisurvey['questionsWithChoices'][question.id].choices[cIndex].offline_evaluation_count:
                  aluminisurvey['questionAnswerSummery'][question.id].choices[choice.id].length
                  )}} <br></span>
              </td>
              <td>{{ Math.round(aluminisurvey['questionAnswerSummery'][question.id].avg_score * 100) / 100 }}</td>
              <td>{{ Math.round(aluminisurvey['questionAnswerSummery'][question.id].persantage * 100) / 100 }}</td>
              <td>
                <span v-if="aluminisurvey['questionAnswerSummery'][question.id].attainment_level">
                  {{ aluminisurvey['questionAnswerSummery'][question.id].attainment_level }}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </b-col>
      <b-col v-if="getReportFlag && survey_ids.alumini_survey !=null">
        Alumni survey report
        <table class="table table-bordered table-striped">
          <thead class="thead-dark text-left">
            <tr>
              <th>PO/PSO</th>
              <th v-for="(po, poIndex) in programme_outcomes" :key="'po1' + poIndex">
                {{ po.code }}</th>
              <th v-for="(pso, psoIndex) in programme_specific_outcomes" :key="'pso1' + psoIndex">
                {{ pso.code }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>Avg. Score</th>
              <td v-for="(po, poIndex) in programme_outcomes" :key="'po' + poIndex">
                <span v-if="aluminisurvey['po_avg_scores'][po.id]>0">
                  {{ Math.round(aluminisurvey['po_avg_scores'][po.id] * 100) / 100 }}
                </span>
                <span v-else>
                    -
                </span>
               </td>
              <td v-for="(pso, psoIndex) in programme_specific_outcomes" :key="'pso' + psoIndex">
                <span v-if="aluminisurvey['pso_avg_scores'][pso.id]>0">
                  {{ Math.round(aluminisurvey['pso_avg_scores'][pso.id] * 100) / 100 }}
                </span>
                <span v-else>
                    -
                </span>
               </td>
            </tr>
            <tr>
              <th>Attainment. Score out of 3</th>
              <td v-for="(po, poIndex) in programme_outcomes" :key="'po' + poIndex">
                <span v-if="aluminisurvey['po_attainment_scores'][po.id]>0">
                  {{ Math.round(aluminisurvey['po_attainment_scores'][po.id] * 100) / 100 }}
                </span>
                <span v-else>
                    -
                </span>
              </td>
              <td v-for="(pso, psoIndex) in programme_specific_outcomes" :key="'pso' + psoIndex">
                <span v-if="aluminisurvey['pso_attainment_scores'][pso.id]>0">
                  {{ Math.round(aluminisurvey['pso_attainment_scores'][pso.id] * 100) / 100 }}
                </span>
                <span v-else>
                    -
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </b-col>
    </b-row>
    <b-row v-if="!fetchData">
      <b-col v-if="(getConfigFlag && !setConfigFlag)">
        Employer surveys
        <table class="table table-bordered table-striped">
          <thead class="thead-dark text-left">
            <tr>
              <td></td>
              <td></td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(survey, courseIndex) in  employer_surveys" :key="courseIndex">
              <td class="align-middle">
                <b-form-radio v-model="survey_ids.employer_survey" name="employer_survey"
                  :value="survey.id"></b-form-radio>
              </td>
              <td class="align-middle">
                {{ survey.name }}
              </td>
            </tr>
          </tbody>
        </table>
      </b-col>
      <b-col v-if="(getDataFlag) && survey_ids.employer_survey!=null">
        Employer survey data
        <table class="table table-bordered table-striped">
          <thead class="thead-dark text-left">
            <tr>
              <th>Q No.</th>
              <th>Question</th>
              <th>PO/PSO</th>
              <th>Choices</th>
              <th>Count</th>
              <th>Avg. Score</th>
              <th>%</th>
              <th>Attainment Level</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(question, qIndex) in employersurvey['exit_survey_questions']" :key="qIndex">
              <td>{{ question.question_no }}</td>
              <td>{{ question.name }}</td>
              <td>
                <span>
                  {{ question.programme_outcomes.map(po => programme_outcomes[po].code).join(', ') }}
                </span>
                <span>
                  {{ question.programme_specific_outcomes.map(pso => programme_specific_outcomes[pso].code).join(', ') }}
                </span>
              </td>
              <td>
                <span v-for="(choice, cIndex) in question.choices" :key="cIndex">{{ choice.name }}({{ choice.score }})
                  <br></span>
              </td>
              <td>
                <span v-for="(choice, cIndex) in question.choices" :key="cIndex">{{
                  Number(employersurvey['questionsWithChoices'][question.id].choices[cIndex].offline_evaluation_count?
                  employersurvey['questionsWithChoices'][question.id].choices[cIndex].offline_evaluation_count:
                  employersurvey['questionAnswerSummery'][question.id].choices[choice.id].length
                  )}} <br></span>
              </td>
              <td>{{ Math.round(employersurvey['questionAnswerSummery'][question.id].avg_score * 100) / 100 }}</td>
              <td>{{ Math.round(employersurvey['questionAnswerSummery'][question.id].persantage * 100) / 100 }}</td>
              <td>
                <span v-if=" employersurvey['questionAnswerSummery'][question.id].attainment_level">
                  {{  employersurvey['questionAnswerSummery'][question.id].attainment_level }}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </b-col>
      <b-col v-if="getReportFlag && survey_ids.employer_survey!=null">
        Employer survey report
        <table class="table table-bordered table-striped">
          <thead class="thead-dark text-left">
            <tr>
              <th>PO/PSO</th>
              <th v-for="(po, poIndex) in programme_outcomes" :key="'po1' + poIndex">
                {{ po.code }}</th>
              <th v-for="(pso, psoIndex) in programme_specific_outcomes" :key="'pso1' + psoIndex">
                {{ pso.code }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>Avg. Score</th>
              <td v-for="(po, poIndex) in programme_outcomes" :key="'po' + poIndex">
                <span v-if="employersurvey['po_avg_scores'][po.id]>0">
                  {{ Math.round(employersurvey['po_avg_scores'][po.id] * 100) / 100 }}
                </span>
                <span v-else>
                    -
                </span>
              </td>
              <td v-for="(pso, psoIndex) in programme_specific_outcomes" :key="'pso' + psoIndex">
                <span v-if="employersurvey['pso_avg_scores'][pso.id]>0">
                  {{ Math.round(employersurvey['pso_avg_scores'][pso.id] * 100) / 100 }}
                </span>
                <span v-else>
                    -
                </span>
              </td>
            </tr>
            <tr>
              <th>Attainment. Score out of 3</th>
              <td v-for="(po, poIndex) in programme_outcomes" :key="'po' + poIndex">
                <span v-if="employersurvey['po_attainment_scores'][po.id]>0">
                  {{ Math.round(employersurvey['po_attainment_scores'][po.id] * 100) / 100 }}
                </span>
                <span v-else>
                    -
                </span>
              </td>
              <td v-for="(pso, psoIndex) in programme_specific_outcomes" :key="'pso' + psoIndex">
                <span v-if="employersurvey['pso_attainment_scores'][pso.id]>0">
                  {{ Math.round(employersurvey['pso_attainment_scores'][pso.id] * 100) / 100 }}
                </span>
                <span v-else>
                    -
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </b-col>
    </b-row>
    <b-row v-if="!fetchData">
      <b-col v-if="(getConfigFlag && !setConfigFlag)">
        Parent surveys
        <table class="table table-bordered table-striped">
          <thead class="thead-dark text-left">
            <tr>
              <td></td>
              <td></td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(survey, courseIndex) in  parent_surveys" :key="courseIndex">
              <td class="align-middle">
                <b-form-radio v-model="survey_ids.parent_survey" name="parent_survey" :value="survey.id"></b-form-radio>
              </td>
              <td class="align-middle">
                {{ survey.name }}
              </td>
            </tr>
          </tbody>
        </table>
      </b-col>
      <b-col v-if="(getDataFlag) && survey_ids.parent_survey !=null">
        Parent survey data
        <table class="table table-bordered table-striped">
          <thead class="thead-dark text-left">
            <tr>
              <th>Q No.</th>
              <th>Question</th>
              <th>PO/PSO</th>
              <th>Choices</th>
              <th>Count</th>
              <th>Avg. Score</th>
              <th>%</th>
              <th>Attainment Level</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(question, qIndex) in parentsurvey['exit_survey_questions']" :key="qIndex">
              <td>{{ question.question_no }}</td>
              <td>{{ question.name }}</td>
              <td>
                <span>
                  {{ question.programme_outcomes.map(po => programme_outcomes[po].code).join(', ') }}
                </span>
                <span>
                  {{ question.programme_specific_outcomes.map(pso => programme_specific_outcomes[pso].code).join(', ') }}
                </span>
              </td>
              <td>
                <span v-for="(choice, cIndex) in question.choices" :key="cIndex">{{ choice.name }}({{ choice.score }})
                  <br></span>
              </td>
              <td>
                <span v-for="(choice, cIndex) in question.choices" :key="cIndex">{{
                  Number( parentsurvey['questionsWithChoices'][question.id].choices[cIndex].offline_evaluation_count?
                  parentsurvey['questionsWithChoices'][question.id].choices[cIndex].offline_evaluation_count:
                  parentsurvey['questionAnswerSummery'][question.id].choices[choice.id].length
                  )}} <br></span>
              </td>
              <td>{{ Math.round(parentsurvey['questionAnswerSummery'][question.id].avg_score * 100) / 100 }}</td>
              <td>{{ Math.round(parentsurvey['questionAnswerSummery'][question.id].persantage * 100) / 100 }}</td>
              <td>
                <span v-if="parentsurvey['questionAnswerSummery'][question.id].attainment_level">
                  {{parentsurvey['questionAnswerSummery'][question.id].attainment_level}}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </b-col>
      <b-col v-if="getReportFlag && survey_ids.parent_survey !=null">
        Parent survey report
        <table class="table table-bordered table-striped">
          <thead class="thead-dark text-left">
            <tr>
              <th>PO/PSO</th>
              <th v-for="(po, poIndex) in programme_outcomes" :key="'po1' + poIndex">
                {{ po.code }}</th>
              <th v-for="(pso, psoIndex) in programme_specific_outcomes" :key="'pso1' + psoIndex">
                {{ pso.code }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>Avg. Score</th>
              <td v-for="(po, poIndex) in programme_outcomes" :key="'po' + poIndex">
                <span v-if="parentsurvey['po_avg_scores'][po.id]>0">
                  {{ Math.round(parentsurvey['po_avg_scores'][po.id] * 100) / 100 }}
                </span>
                <span v-else>
                    -
                </span>
              </td>
              <td v-for="(pso, psoIndex) in programme_specific_outcomes" :key="'pso' + psoIndex">
                <span v-if="parentsurvey['pso_avg_scores'][pso.id]>0">
                  {{ Math.round(parentsurvey['pso_avg_scores'][pso.id] * 100) / 100 }}
                </span>
                <span v-else>
                    -
                </span>
              </td>
            </tr>
            <tr>
              <th>Attainment. Score out of 3</th>
              <td v-for="(po, poIndex) in programme_outcomes" :key="'po' + poIndex">
                <span v-if="parentsurvey['po_attainment_scores'][po.id]>0">
                  {{ Math.round(parentsurvey['po_attainment_scores'][po.id] * 100) / 100 }}
                </span>
                <span v-else>
                    -
                </span>
              </td>
              <td v-for="(pso, psoIndex) in programme_specific_outcomes" :key="'pso' + psoIndex">
                <span v-if="parentsurvey['pso_attainment_scores'][pso.id]>0">
                  {{ Math.round(parentsurvey['pso_attainment_scores'][pso.id] * 100) / 100 }}
                </span>
                <span v-else>
                    -
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </b-col>
    </b-row>
  </div>
</template>

<script>
// import DatePicker from "vue2-datepicker";
export default {
  props: ["usersubgroupid"],
  async created() {
    this.getConfig();
  },
  components: {
    // DatePicker,
  },
  data() {
    return {
      getConfigFlag: true,
      setConfigFlag: false,
      getDataFlag: false,
      getReportFlag: false,
      fetchData: false,
      program_exit_surveys: [],
      faculty_surveys: [],
      alumini_surveys: [],
      employer_surveys: [],
      parent_surveys: [],
      survey_ids: {
        programme_exit_survey: null,
        faculty_survey: null,
        parent_survey: null,
        employer_survey: null,
        alumini_survey: null,
      },
      programmeexitsurvey: {},
      facultysurvey: {},
      parentsurvey: {},
      employersurvey: {},
      aluminisurvey: {},
      programme_specific_outcomes: [],
      programme_outcomes: [],
    };
  },
  methods: {
    ClearSurveyIds() {
      this.survey_ids.programme_exit_survey = null;
      this.survey_ids.faculty_survey = null;
      this.survey_ids.parent_survey = null;
      this.survey_ids.employer_survey = null;
      this.survey_ids.alumini_survey = null;
    },
    async getConfig() {
      this.fetchData = true;
      const url =
        this.$store.getters.getAPIKey.mainAPI + `/poattainment/getconfig`;
      await this.$axios
        .post(url, {
          subgroup: this.usersubgroupid,
          step: "programmeexitsurvey",
          survey_ids: this.survey_ids,
        })
        .then((response) => {
          this.program_exit_surveys = response.data.program_exit_surveys;
          this.faculty_surveys = response.data.faculty_surveys;
          this.alumini_surveys = response.data.alumini_surveys;
          this.employer_surveys = response.data.employer_surveys;
          this.parent_surveys = response.data.parent_surveys;
          this.survey_ids.programme_exit_survey = response.data.programexitsurvey;
          this.survey_ids.faculty_survey = response.data.facultysurvey;
          this.survey_ids.parent_survey = response.data.parentsurvey;
          this.survey_ids.employer_survey = response.data.employersurvey;
          this.survey_ids.alumini_survey = response.data.aluminisurvey;
        })
        .catch((error) => {
          this.$toast.error(error.response.data.message, {
            position: "top",
            duration: 3000,
          });
        });
      this.fetchData = false;
    },
    async setConfig() {
      this.fetchData = true;
      const url =
        this.$store.getters.getAPIKey.mainAPI + `/poattainment/setconfig`;
      await this.$axios
        .post(url, {
          subgroup: this.usersubgroupid,
          survey_ids: this.survey_ids,
          step: "programmeexitsurvey",
        })
        .then((response) => {
          response;
          this.setConfigFlag = true;
          this.getData();
        })
        .catch((error) => {
          this.$toast.error(error.response.data.message, {
            position: "top",
            duration: 3000,
          });
        });
    },
    async getData() {
      this.fetchData = true;
      const url =
        this.$store.getters.getAPIKey.mainAPI + `/poattainment/getdata`;
      await this.$axios
        .post(url, {
          subgroup: this.usersubgroupid,
          step: "programmeexitsurvey",
        })
        .then((response) => {
          let res = response.data;
          this.programmeexitsurvey = res.programmeexitsurvey;
          this.facultysurvey = res.facultysurvey;
          this.parentsurvey = res.parentsurvey;
          this.employersurvey = res.employersurvey;
          this.aluminisurvey = res.aluminisurvey;
          this.programme_specific_outcomes = res.programme_specific_outcomes;
          this.programme_outcomes = res.programme_outcomes;
        })
        .catch((error) => {
          this.$toast.error(error.response.data.message, {
            position: "top",
            duration: 3000,
          });
        });
      this.getDataFlag = true;
      this.fetchData = false;
    },
    async getReport() {
      this.fetchData = true;
      const url =
        this.$store.getters.getAPIKey.mainAPI + `/poattainment/report`;
      await this.$axios
        .post(url, {
          subgroup: this.usersubgroupid,
          step: "programmeexitsurvey",
        })
        .then((response) => {
          let res = response.data;
          this.programmeexitsurvey = res.programmeexitsurvey;
          this.facultysurvey = res.facultysurvey;
          this.parentsurvey = res.parentsurvey;
          this.employersurvey = res.employersurvey;
          this.aluminisurvey = res.aluminisurvey;
          this.programme_specific_outcomes = res.programme_specific_outcomes;
          this.programme_outcomes = res.programme_outcomes;
        })
        .catch((error) => {
          this.$toast.error(error.response.data.message, {
            position: "top",
            duration: 3000,
          });
        });

      this.getReportFlag = true;
      this.fetchData = false;
    },
    // selectAllSubgroups() {},
  },
};
</script>
